import { type ApiResponse, FmsApi } from "../fmsapi"
import { type iUpdateReqCancel } from "../models/requestdto"
import { type PaymentOption, type PAY_Complete_Inicis } from "../models/responsedto"
import BaseController from "./base"

export class PaymentController extends BaseController {
  constructor(api: FmsApi) {
    super(api, "payment")
  }

  public async regPaymentReqInfo(params: {
    visitor_id: number
    fair_visitor_id: number
    req_cnt: number
    mobile: string
    mobile_yn: string
    ip_addr: string
    payment_method: number | null
    create_user: string
    coupon_codes: string
    req_id: number
    fair_id: number
    order_price: number // 주문금액 (총액, 부가세포함)
    total_price: number // 실제금액 (총액, 부가세포함)
    discount_price: number // 할인금액 (총액)
    option_id: number // 결제 옵션 아이디
    pay_method: number // 결제방법(마스터코드) ( SELECT * FROM MASTER_CODE WHERE MASTER_CODE_GROUP_ID = 11 )
    pay_type: number // 1: 사전등록/ 2:세미나(단일&기간권)/ 3: 업체참가비
    reg_type: number
  }): Promise<ApiResponse> {
    return await this.callApi("regPaymentReqInfo", params)
  }

  public async updatePaymentComplete(params: { imp_uid: string; merchant_uid: string; pay_method: string }): Promise<PAY_Complete_Inicis> {
    return await this.callApi("PAY_Complete_Inicis", params)
  }

  public async updateReqCancel(params: iUpdateReqCancel): Promise<ApiResponse> {
    return await this.callApi("updateReqCancel", params)
  }

  public async getPaymentOption(fair_id: number, payment_option_id: number | null): Promise<PaymentOption[] | null> {
    return await this.callApi("PAY_sd_Option", {
      fair_id: fair_id,
      payment_option_id: null,
    })
  }
}
